/**
 * <PosterList />
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './PosterList.scss';
import PosterCard from './PosterCard';

class PosterList extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  render() {
    const {
      list,
      count,
      onSelect,
      onDelete,
      onUnlink,
      onFetch
    } = this.props;

    return (
      <div className='poster-list-wrapper'>
        <div className='poster-list'>
        {list.map((poster, key)=>{
          return <PosterCard index={key} key={key} poster={poster} onSelect={onSelect} onDelete={onDelete} onUnlink={onUnlink} onFetch={onFetch} />
        })}
        </div>
      </div>
    )
  }
}

export default PosterList;



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/PosterList/index.js